import { ComponentProps } from "react";
import { Trans } from "next-i18next";

import LandingSectionServiceIntro from "@sellernote/shipda-kr/src/components/landing/LandingSectionServiceIntro";
import { SubSectionData } from "@sellernote/shipda-kr/src/components/landing/LandingSubSection/types";

const ALIBABA_SOURCING_COLOR = "#FE7023";

const SERVICE_INTRO_SECTION_DATA: Pick<
  ComponentProps<typeof LandingSectionServiceIntro>,
  | "title"
  | "desc"
  | "mobileDesc"
  | "backgroundImageUrl"
  | "backgroundMobileImageUrl"
  | "badgeList"
  | "guideDesc"
> = {
  title: (
    <Trans
      i18nKey="page-sourcing:알리바바닷컴_주문_결제_시_br_/_무역대금_3_를_물류비_쿠폰으로_"
      components={{
        br: <br />,
      }}
    />
  ),
  desc: (
    <Trans
      i18nKey="page-sourcing:디지털_포워딩__쉽다_를_통해_알리바바닷컴_소싱을_시작하세요._br_/_공식_제휴로_결제액의_3_를_수출입운송_쿠폰으로_제공해요."
      components={{
        br: <br />,
      }}
    />
  ),
  backgroundImageUrl: "/assets/images/sourcing/intro-section-bg.webp",
  backgroundMobileImageUrl: "/assets/images/sourcing/intro-section-bg-m.webp",
  badgeList: [`ALIBABA.COM`, `IMPORT`, `SOURCING`],
};

const SUB_SECTION_DATA: SubSectionData[] = [
  {
    chipLabel: `Step 1`,
    title: (
      <Trans
        i18nKey="page-sourcing:쉽다_접속_이후_br_/_알리바바닷컴_페이지_이동"
        components={{
          br: <br />,
        }}
      />
    ),
    desc: (
      <Trans
        i18nKey="page-sourcing:마이페이지___상품소싱_탭을_클릭하세요._이후_알리바바닷컴으로_이동합니다._br_/_알리바바닷컴에서_상품을_선정하고_신규_주문을_생성하세요."
        components={{
          br: <br />,
        }}
      />
    ),
    imageInfo: {
      url: "/assets/images/sourcing/sub-section-step1.webp",
      width: 548,
      height: 420,
      unoptimized: true,
    },
    mobileImageInfo: {
      url: "/assets/images/sourcing/sub-section-step1-m.webp",
      width: 328,
      height: 260,
      unoptimized: true,
    },
    layoutAlign: "left",
  },
  {
    chipLabel: `Step 2`,
    title: (
      <Trans
        i18nKey="page-sourcing:주문서_생성_및_결제_진행"
        components={{
          br: <br />,
        }}
      />
    ),
    desc: (
      <Trans
        i18nKey="page-sourcing:수출자와_협의된_내역에_맞춰_주문서를_확인하세요._br_/_주문서_생성_이후_15일_이내_결제를_진행하세요._br_/___결제_후_쿠폰이_자동_발급됩니다._최대_3영업일_소요_"
        components={{
          br: <br />,
        }}
      />
    ),
    imageInfo: {
      url: "/assets/images/sourcing/sub-section-step2.webp",
      width: 548,
      height: 420,
      unoptimized: true,
    },
    mobileImageInfo: {
      url: "/assets/images/sourcing/sub-section-step2-m.webp",
      width: 328,
      height: 260,
      unoptimized: true,
    },
    layoutAlign: "right",
  },
  {
    chipLabel: `Step 3`,
    title: (
      <Trans
        i18nKey="page-sourcing:운송의뢰_생성_및_쿠폰_적용"
        components={{
          br: <br />,
        }}
      />
    ),
    desc: (
      <Trans
        i18nKey="page-sourcing:디지털_포워딩__쉽다_에_수출입_운송을_의뢰하세요._br/_발급된_쿠폰을_적용하면_할인된_금액으로_운송을_시작할_수_있어요._br_/___발급된_쿠폰은_수출__수입운송_모두_사용가능_합니다._"
        components={{
          br: <br />,
        }}
      />
    ),
    imageInfo: {
      url: "/assets/images/sourcing/sub-section-step3.webp",
      width: 548,
      height: 420,
      unoptimized: true,
    },
    mobileImageInfo: {
      url: "/assets/images/sourcing/sub-section-step3-m.webp",
      width: 328,
      height: 260,
      unoptimized: true,
    },
    layoutAlign: "left",
  },
];

export { ALIBABA_SOURCING_COLOR, SERVICE_INTRO_SECTION_DATA, SUB_SECTION_DATA };
